var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.loaded)?_c('router-view'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }